import React, { useCallback, useState } from 'react'
import './style.scss'
import { useDispatch } from 'react-redux'
import { setShowModalExportTemplate } from 'features/TemplateInvoice/templateInvoiceSlice'
import { useSelector } from 'react-redux'
import { Tooltip } from 'antd'
import ModalConfirm from 'general/components/Modal/ModalConfirm'

function CreateTemplateInvoiceHeader(props) {
  const dispatch = useDispatch()
  const {
    style,
    isAppliedDecree70,
    updateInvoiceTemplateFollowByDecree70,
    templateInvoiceInstance,
    isAllowUpdateTemplateFollowByDecree70,
  } = props

  const [modalStates, setModalsState] = useState({})
  const updateModalState = useCallback(
    (stateName, value) => {
      const modalStatesClone = { ...modalStates }
      modalStatesClone[stateName] = value
      setModalsState(modalStatesClone)
    },
    [modalStates],
  )

  const { templateInvoiceName, templateInvoiceSeries } = useSelector(
    (state) => state.templateInvoice.instance,
  )
  const isDecree70Template = useCallback(() => {
    const sellerInfo = templateInvoiceInstance.RegionConfigs.find(
      (region) => region.regionName == 'sellerInfo',
    )
    return sellerInfo.regionConfigs.find(
      (field) => field.dataField == 'branchCode',
    )
  }, [templateInvoiceInstance.RegionConfigs])

  return (
    <div
      className="CreateTemplateInvoiceHeader m-auto"
      style={{ ...style, maxWidth: 1265, minWidth: 1265 }}
    >
      <div className="px-4 py-2 d-flex flex-row justify-content-between align-items-center">
        <div className="position-relative">
          <h3 className="static-title mb-1">Thiết lập mẫu hóa đơn</h3>
          {templateInvoiceName && templateInvoiceSeries && (
            <p className="mb-0 dynamic-title">{`${templateInvoiceName} (${templateInvoiceSeries})`}</p>
          )}
          {/* <button
            className="btn btn-icon position-absolute"
            style={{ top: '10%', right: '100%' }}
            onClick={() => {
              navigate(-1);
            }}
          >
            <i className="fas fa-arrow-left" style={{ color: '#000000' }}></i>
          </button> */}
        </div>

        <div className="d-flex align-items-center">
          {!isAppliedDecree70 &&
            !isDecree70Template() &&
            isAllowUpdateTemplateFollowByDecree70() && (
              <Tooltip title="Thêm các trường thông tin hiển thị trên mẫu hóa đơn theo nghị định 70">
                <button
                  className="btn btn-warning d-flex flex-row align-items-center mr-2"
                  style={{ fontSize: '1.1rem', fontWeight: 400 }}
                  onClick={() => updateModalState('confirmModal', true)}
                >
                  <i className="fa-solid fa-share-from-square mr-1"></i>
                  <p className="mb-0">Cập nhật mẫu theo NĐ 254</p>
                </button>
              </Tooltip>
            )}
          <button
            className="btn btn-secondary d-flex flex-row align-items-center"
            style={{ fontSize: '1.1rem', fontWeight: 400 }}
            onClick={() => dispatch(setShowModalExportTemplate(true))}
          >
            <i className="fa-solid fa-share-from-square mr-1"></i>
            <p className="mb-0">Xuất mẫu</p>
          </button>
        </div>
      </div>
      <ModalConfirm
        header="Xác nhận"
        content="Khi cập nhật mẫu hóa đơn lên nghị định 70, bạn sẽ mất các thao tác vừa thực hiện nếu có. Bạn có muốn cập nhật không?"
        show={modalStates.confirmModal}
        setShow={(status) => updateModalState('confirmModal', status)}
        handleConfirm={() => {
          updateInvoiceTemplateFollowByDecree70()
        }}
      />
    </div>
  )
}

export default CreateTemplateInvoiceHeader
